import React from 'react';
import GlobalStyles from './styles/GlobalStyles';
import Layout from './components/Layout';

function App() {
	return (
		<>
			<Layout/>
			<GlobalStyles/>
		</>
	);
}

export default App;
